<div >
  <router-outlet #outlet="outlet"></router-outlet>
</div>

<div id="dialog-container" class="hidden"></div>
<img #esImg src="" alt="" width="1px" height="1px" style="display: none">